/* eslint-disable @typescript-eslint/no-explicit-any */
import { useContext, useCallback } from 'react';
import { CAContext } from '../../contexts/CAContext';
import { NRAttributes } from '../../interfaces/nr-interfaces';
import { getChatbotEnv, getMIAWEnv, getRestId, getRestIdWithoutCounter } from '../../utils/session-storage-utils';
import { ILogName, logMapping } from '../../utils/chat/chat-nr-logging';
import { ChatbotContext } from '../../contexts/ChatbotContext';
import { useIdentity } from '@vp/auth-react';
import { IIdentityObject } from '../../interfaces/app-interfaces';

declare global {
  interface Window {
    newrelic: any;
    tracking: any;
  }
}

export const useNRLogging = (): {
  initNR: () => void;
  logCustomAttributesNR: (pageAction: string, attributes: NRAttributes) => void;
  logChat: (logName: ILogName, additionalProperties: unknown) => void;
} => {
  const identity = useIdentity();
  const isSignedIn = (identity as IIdentityObject)?.isSignedIn;

  const {
    chatState: { locale },
  } = useContext(CAContext);

  const {
    state: { sessionId },
  } = useContext(ChatbotContext);

  const initNR = useCallback(() => {
    const pageURL = window?.location.href;

    if (window && window?.newrelic) {
      return;
    }
    if (pageURL?.includes('localhost')) {
      console.info('NR not initialized for local env');
    }
  }, []);

  const logCustomAttributesNR = useCallback(
    (pageAction: string, attributes: NRAttributes) => {
      let env: string;
      const pageURL = window?.location.href;
      const chatbotEnv = getChatbotEnv();
      const miawEnv = getMIAWEnv();
      if (pageURL?.includes('staging') || pageURL?.includes('localhost')) {
        env = 'dev';
      } else env = 'production';
      if (window && window?.newrelic && window?.newrelic.addPageAction) {
        window?.newrelic.addPageAction(pageAction, {
          ...attributes,
          environment: env,
          chatbotEnvironment: chatbotEnv,
          miawEnvironment: miawEnv,
          locale,
          caChatbotLogKey: getRestIdWithoutCounter(),
          caRequestID: getRestId(false),
          chatbotSessionId: sessionId || '',
          isLoggedIn: isSignedIn || false,
        });
      }
    },
    [sessionId, locale],
  );

  const logChat = useCallback((logName: ILogName, additionalInfo: unknown) => {
    // const pageURL = window?.location.href;
    let attributes = logMapping(logName, locale);
    const caLogKey = getRestIdWithoutCounter();
    if ((typeof additionalInfo) in ['boolean', 'string', 'number']) {
      attributes = { ...attributes, additionalInfo };
    } else if (typeof additionalInfo === 'object') {
      attributes = { ...attributes, ...additionalInfo };
    }

    console.info(logName, { attributes }, caLogKey);
    // set the event name in NR
    const pageAction = 'chat_anywhere';
    if (window && window.newrelic) {
      window.newrelic.addPageAction(pageAction, { ...attributes, caLogKey });
    }
  }, []);
  return { initNR, logCustomAttributesNR, logChat };
};
